import { ViewportScroller } from '@angular/common';
import { Component } from '@angular/core';
import { GlobalMessageEntities, GlobalMessageType, GlobalMessageService } from '@spartacus/core';
import { ICON_TYPE } from '@spartacus/storefront';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'cx-global-message',
    templateUrl: './kb-global-message.component.html',
    styleUrls: ['./kb-global-message.component.scss'],
    standalone: false
})
export class KbGlobalMessageComponent {
  iconTypes = ICON_TYPE;
  key1 = 'httpHandlers.cartNotFound';
  key2 = 'httpHandlers.sessionExpired';
  key3 = 'authMessages.signedOutSuccessfully';
  key4 = 'httpHandlers.forbidden';
  key5 = 'httpHandlers.internalServerError';
  messages$: Observable<GlobalMessageEntities>;
  messageType: typeof GlobalMessageType = GlobalMessageType;
  //for unsubscribing
  private unsubscribe$ = new Subject<void>();
  isDeleting = false;
  constructor(protected globalMessageService: GlobalMessageService,
    private viewportScroller: ViewportScroller,
  ) { }

  ngOnInit(): void {
    this.messages$ = this.globalMessageService.get();
    this.globalMessageService.get().pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe((key) => {
      if ('[GlobalMessage] Error' in key) {
        if (key['[GlobalMessage] Error'].length !== 0) {
          this.viewportScroller.scrollToPosition([0, 50]);
        }
      }
      if ('[GlobalMessage] Information' in key) {
        if (key['[GlobalMessage] Information'].length !== 0) {
          this.viewportScroller.scrollToPosition([0, 50]);
        }
      }
    });
  }

  clear(type: GlobalMessageType, index: number): void {
    this.globalMessageService.remove(type, index);
  }
  canShowThisError(key: any): boolean {
    if (key.key == this.key1) {
      return false;
    }
    else if (key.key == this.key2) {
      return false;
    }
    else if (key.key == this.key3) {
      return false;
    }
    else if (key.key == this.key4) {
      return false;
    }
    else if (key.key == this.key5) {
      return false;
    }
    else if (key?.raw?.includes('not found for current user in current BaseStore')) {
      return false;
    }
    else if (key?.raw?.includes('CountryModel with isocode')) {
      return false;
    }
    else if (key?.raw?.includes('BaseStore with uid')) {
      return false;
    }
    else if (key?.raw?.includes('Encrypted data')) {
      return false;
    }
    else {
      return true;
    }

  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }



}
